import { formatCohortDate } from '../format/formatCohortDate'
import type { CohortConfig, CohortContent, CohortHeroFact } from '../types'

export type HeroFactView = Pick<CohortHeroFact, 'kind' | 'label'> & {
  value: string
}

const DERIVED_VALUES = {
  startDate: (config: CohortConfig) =>
    formatCohortDate(config.startDate, config.timezone),
  duration: (config: CohortConfig, formatDuration: (weeks: number) => string) =>
    formatDuration(config.durationWeeks),
}

export const getHeroFacts = (
  config: CohortConfig,
  content: CohortContent,
  formatDuration: (weeks: number) => string,
): HeroFactView[] =>
  content.hero.facts.map((fact) => ({
    kind: fact.kind,
    label: fact.label,
    value:
      'value' in fact
        ? fact.value
        : DERIVED_VALUES[fact.kind](config, formatDuration),
  }))
